import React from 'react';

const Logo: React.FC = () => (
  <div>
    <svg
      width={'200'}
      height={'75'}
      viewBox={'0 0 200 75'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <g clipPath={'url(#clip0_11870_104519)'}>
        <path
          d={'M152.701 51.8634H162.289V26.9707H152.701V51.8634Z'}
          fill={'#4f78a0'}
        />
        <path
          d={'M150.3 19.6748L150.301 51.8636H140.715V19.6748H150.3Z'}
          fill={'#4f78a0'}
        />
        <path
          d={'M174.278 12.3779H164.693V51.8629H174.278V12.3779Z'}
          fill={'#4f78a0'}
        />
        <path
          d={
            'M199.857 26.9709V19.6748H178.855V19.732V51.8064V51.8636H199.857V44.5675H187.439V39.3887H197.911V32.1498H187.439V26.9709H199.857Z'
          }
          fill={'#4f78a0'}
        />
        <path
          d={
            'M52.9617 19.2168C43.8344 19.2168 36.4238 26.6274 36.4238 35.7547C36.4238 44.882 43.8344 52.2926 52.9617 52.2926C62.0891 52.2926 69.4996 44.882 69.4996 35.7547C69.4996 26.6274 62.0891 19.2168 52.9617 19.2168ZM52.9617 45.0537C47.926 45.0537 43.863 40.9049 43.863 35.7547C43.863 30.6045 47.9546 26.4557 52.9617 26.4557C57.9975 26.4557 62.0604 30.6045 62.0604 35.7547C62.0604 40.9049 57.9975 45.0537 52.9617 45.0537Z'
          }
          fill={'#44c8f5'}
        />
        <path
          d={
            'M32.3891 32.0351H16.5379V39.274H24.9785C23.6052 42.6503 20.3433 45.0537 16.5379 45.0537C13.9914 45.0537 11.6738 43.995 10.0429 42.2497C8.44063 40.5616 7.4392 38.2726 7.4392 35.7547C7.4392 30.6331 11.5308 26.4557 16.5379 26.4557C19.0844 26.4557 21.402 27.5144 23.0329 29.2597L28.2403 24.0523C25.2647 21.048 21.1159 19.2168 16.5379 19.2168C7.41059 19.2168 0 26.6274 0 35.7547C0 40.3327 1.8598 44.4528 4.83548 47.4571C7.83977 50.4614 11.9599 52.2926 16.5379 52.2926C24.4635 52.2926 30.7582 46.7132 32.3605 39.274C32.618 38.1295 33.1044 34.7533 32.3891 32.0351Z'
          }
          fill={'#44c8f5'}
        />
        <path
          d={
            'M129.642 51.8636H137.625L126.008 19.6748H117.224L105.607 51.8636H113.59L115.507 46.5131H127.696L129.642 51.8636ZM118.111 39.2742L121.602 29.6033L125.092 39.2742H118.111Z'
          }
          fill={'#4f78a0'}
        />
        <path
          d={
            'M105.522 32.0351H89.6707V39.274H98.1114C96.738 42.6503 93.5048 45.0537 89.6707 45.0537C87.1242 45.0537 84.8066 43.995 83.1757 42.2497C81.5734 40.5616 80.572 38.2726 80.572 35.7547C80.572 30.6331 84.6636 26.4557 89.6707 26.4557C92.2172 26.4557 94.5348 27.5144 96.1657 29.2597L101.373 24.0523C98.3689 21.048 94.2487 19.2168 89.6707 19.2168C80.5434 19.2168 73.1328 26.6274 73.1328 35.7547C73.1328 40.3327 74.9926 44.4528 77.9683 47.4571C80.9726 50.4614 85.0928 52.2926 89.6707 52.2926C97.5963 52.2926 103.862 46.7132 105.493 39.274C105.751 38.1295 106.237 34.7533 105.522 32.0351Z'
          }
          fill={'#4f78a0'}
        />
        <path
          d={
            'M2.51758 64.7959H4.83517C6.09412 64.7959 6.9811 65.3681 6.9811 66.4554C6.9811 66.9704 6.72359 67.5141 6.23718 67.8002V67.8288C6.95248 68.0577 7.23861 68.6872 7.23861 69.2594C7.23861 70.6328 6.09412 71.1478 4.83517 71.1478H2.51758V64.7959ZM4.86379 67.2566C5.26436 67.2566 5.40742 66.9704 5.40742 66.6843C5.40742 66.3982 5.23575 66.1407 4.83517 66.1407H4.06264V67.2566H4.86379ZM4.97824 69.7744C5.43603 69.7744 5.63632 69.4597 5.63632 69.1164C5.63632 68.773 5.43603 68.4583 4.97824 68.4583H4.03403V69.7744H4.97824Z'
          }
          fill={'#626262'}
        />
        <path
          d={
            'M13.3621 68.5155L11.2734 64.7959H13.0188L13.7341 66.3124C13.9344 66.7415 14.1061 67.2279 14.1061 67.2279H14.1347C14.1347 67.2279 14.3063 66.7415 14.5066 66.3124L15.2219 64.7959H16.9673L14.8786 68.5155V71.0906H13.3335V68.5155H13.3621Z'
          }
          fill={'#626262'}
        />
        <path
          d={
            'M27.5527 64.7959H30.1851C31.4154 64.7959 32.2452 65.6829 32.2452 66.9704C32.2452 68.2294 31.4154 69.145 30.1851 69.145H29.0978V71.0906H27.5527V64.7959ZM29.8703 67.8288C30.414 67.8288 30.6715 67.4568 30.6715 66.9704C30.6715 66.4554 30.414 66.1121 29.8989 66.1121H29.1264V67.8288H29.8703Z'
          }
          fill={'#626262'}
        />
        <path
          d={'M37.168 64.7959H38.713V69.7744H41.2881V71.0906H37.168V64.7959Z'}
          fill={'#626262'}
        />
        <path
          d={
            'M47.5529 64.7959H49.1838L51.3297 71.0906H49.756L49.3554 69.7744H47.3812L47.0092 71.0906H45.4355L47.5529 64.7959ZM48.9835 68.5441L48.6401 67.3138C48.5257 66.9132 48.3826 66.2265 48.3826 66.2265H48.354C48.354 66.2265 48.2109 66.9132 48.0965 67.3138L47.7245 68.5441H48.9835Z'
          }
          fill={'#626262'}
        />
        <path
          d={
            'M55.9941 64.7959H58.1973C58.8268 64.7959 59.1415 64.8531 59.4276 64.939C60.1429 65.2251 60.6007 65.8546 60.6007 66.7702C60.6007 67.4282 60.286 68.1722 59.6565 68.4869V68.5155C59.6565 68.5155 59.7424 68.6299 59.8854 68.8875L61.1157 71.0906H59.399L58.2831 68.9733H57.5678V71.0906H56.0228V64.7959H55.9941ZM58.2259 67.6571C58.7123 67.6571 59.027 67.371 59.027 66.8846C59.027 66.5699 58.9412 66.341 58.6551 66.2265C58.512 66.1693 58.3404 66.1407 58.0828 66.1407H57.5678V67.6857H58.2259V67.6571Z'
          }
          fill={'#626262'}
        />
        <path
          d={'M65.8652 64.7959H67.4103V71.0906H65.8652V64.7959Z'}
          fill={'#626262'}
        />
        <path
          d={
            'M72.7031 64.7959H74.2482V68.773C74.2482 69.4311 74.6774 69.7744 75.3355 69.7744C75.9935 69.7744 76.4227 69.4311 76.4227 68.773V64.7959H77.9678V68.773C77.9678 70.2036 76.9377 71.2051 75.3355 71.2051C73.7332 71.2051 72.7031 70.2036 72.7031 68.773V64.7959Z'
          }
          fill={'#626262'}
        />
        <path
          d={
            'M83.5756 64.7959H85.2637L86.1793 67.4568C86.3224 67.8574 86.494 68.4869 86.494 68.4869H86.5226C86.5226 68.4869 86.6943 67.8574 86.8374 67.4568L87.753 64.7959H89.4411L89.9561 71.0906H88.4111L88.2108 68.258C88.1821 67.7716 88.2108 67.1993 88.2108 67.1993H88.1822C88.1822 67.1993 87.9819 67.8574 87.8388 68.258L87.1807 70.0892H85.8359L85.1779 68.258C85.0348 67.8574 84.8345 67.1993 84.8345 67.1993H84.8059C84.8059 67.1993 84.8345 67.7716 84.8059 68.258L84.6056 71.0906H83.0605L83.5756 64.7959Z'
          }
          fill={'#626262'}
        />
      </g>
      <defs>
        <clipPath id={'clip0_11870_104519'}>
          <rect width={'200'} height={'75'} fill={'white'} />
        </clipPath>
      </defs>
    </svg>
  </div>
);

export default Logo;
